import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { Button, Grid, Typography } from "@mui/material";
import * as React from "react";
import { getInputBox } from "../../../../sharedComponents/formFields/LabelInFormFields";
import TitleTooltip from "../../../../sharedComponents/Tooltip/TitleTooltip";
import { useStyles } from "./UpdatePlayerDetails";

const SocialMediaComponent = ({
  formData,
  handleInputChange,
  checkIfSaveButtonDisabled,
  handleSubmit,
}) => {
  const classes = useStyles();

  return (
    <>
      <Typography
        noWrap
        variant="subtitle1"
        className={classes.firstSectionTitle}
      >
        Social Media
      </Typography>
      <Grid container sx={{ paddingTop: "27px" }}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          {getInputBox("Twitter", formData.twitter, (e) => {
            handleInputChange(e, "twitter");
          })}
        </Grid>
      </Grid>
      <Grid container sx={{ textAlign: "right" }}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          {getInputBox("Instagram", formData.instagram, (e) => {
            handleInputChange(e, "instagram");
          })}
        </Grid>
        <Grid item lg={12} pt={2.8}>
          <Button
            sx={{
              textTransform: "none",
              padding: "2px 2px",
              minWidth: "20px !important",
            }}
            size="small"
            variant="contained"
            title="Save"
            disabled={checkIfSaveButtonDisabled()}
            onClick={handleSubmit}
          >
            <TitleTooltip title="Save personal details">
              <SaveOutlinedIcon />
            </TitleTooltip>
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default React.memo(SocialMediaComponent);
